import useRoutesHandler from "@/Hooks/useRouteHandler";
import useToggleHandler from "@/Hooks/useToggleHandler";
import { handleSuccessToast } from "@/UI/Toasts";
import { handleGlobalDeleteRequest } from "@repo/api-services/changeRequestsGlobal.ts";
import URLS from "@repo/api-services/URLS";
import { THookProps } from "@/types/global.types";
import { handleNetworkError } from "@/utility/networkError.utility";
import { useGetAllPartnerServices } from "@repo/api-services/admin";
// import { useGetAllPartnerServices } from "@repo/api-services/usePartnerService.ts";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

const usePartners = ({ enablePerPage = false }: THookProps) => {
  // States
  const [deleteRecordId, setDeleteRecord] = useState<number | undefined>();
  const [parentData, setParentData] = useState<any>("");
  // Hooks
  const { urlQueries } = useRoutesHandler();

  const { isOpen: isConfirmModal, toggler: deleteModalToggler } =
    useToggleHandler();

  //URL functions
  const page = urlQueries.page || "1";
  const per_page = enablePerPage ? urlQueries.pagesize || "15" : "700";
  // Services
  const {
    services: { allPartnersService },
    states: { searchQuery, setSearchQuery },
  } = useGetAllPartnerServices({ page, per_page });

  const deleteMutation = useMutation({
    mutationFn: (id: number) =>
      handleGlobalDeleteRequest({ url: `${URLS.PARTNERS}/${id}` }),
    onSuccess: () => {
      allPartnersService.refetch();
      confirmModalToggler();
      setDeleteRecord(undefined);
      handleSuccessToast({ message: "Partner deleted successfully" });
    },
    onError: ({ response }: { response: Error }) => {
      handleNetworkError(response);
    },
  });

  function confirmModalToggler() {
    if (isConfirmModal) {
      setDeleteRecord(undefined);
    }
    deleteModalToggler();
  }

  const deletePartnerHandler = (id: number) => {
    deleteMutation.mutate(id);
  };
  return {
    states: {
      isConfirmModal,
      searchQuery,
      deleteRecordId,
      setDeleteRecord,
      setSearchQuery,
      parentData,
      setParentData,
    },
    functions: {
      confirmModalToggler,
      deletePartnerHandler,
    },
    services: { allPartnersService },
    mutations: { deleteMutation },
  };
};

export default usePartners;
